import { connect } from 'react-redux';
import PlanningBoard from '../components/planning-board';
import { setFullScreen } from '../containers/planning-board-actions';

const mapStateToProps = state => ({
  viewMode: state.planningBoard.viewMode,
  fullScreen: state.planningBoard.fullScreen,
});

const mapDispatchToProps = {
  setFullScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoard);
